import { toast } from 'sonner';

import { extractApiError } from '@/lib/shared-utils';

/**
 * Show a toast for an API error response.
 * Walks nested validation payloads (e.g. { vendor: { pan_number: ["..."] } })
 * and surfaces the real backend message instead of a generic fallback.
 */
export function toastApiError(data: unknown, fallback: string) {
    toast.error(extractApiError(data, fallback));
}
